/**
 * Every antd overlay that should take an Escape before the page does. antd
 * renders each into a body portal, so they are found from the document, not
 * from inside the component that opened them.
 */
const OVERLAY_SELECTOR = [
  '.ant-select-dropdown:not(.ant-select-dropdown-hidden)',
  '.ant-dropdown:not(.ant-dropdown-hidden)',
  '.ant-popover:not(.ant-popover-hidden)',
  '.ant-picker-dropdown:not(.ant-picker-dropdown-hidden)',
  '.ant-modal-wrap',
].join(',')

/**
 * Whether an antd overlay is open on screen.
 *
 * Being in the document is not enough: a closed Modal without `destroyOnClose`
 * stays mounted, its `.ant-modal-wrap` set to `display: none`. Counting it as
 * open would swallow every later Escape until the page reloads.
 */
export const hasOpenOverlay = (): boolean =>
  Array.from(document.querySelectorAll<HTMLElement>(OVERLAY_SELECTOR)).some(
    (element) => window.getComputedStyle(element).display !== 'none'
  )
